export enum AxnReferenceDataTypes {
    AXN_ADMIN_AVAILABLE_USER_RP_PROPERTY = "axnAdminAvailableUserRpProperty",
    AXN_ADMIN_AVAILABLE_USER_ORGANIZATION_PROPERTY = "axnAdminAvailableUserOrganizationProperty",
    AXN_ADMIN_SECURITY_RULE = "axnAdminSecurityRule",
    AXN_AP_ASSERTION = "axnAPAssertion",
    AXN_ASSERTION = "axnAssertion",
    AXN_ASSERTION_ATTRIBUTE = "axnAssertionAttribute",
    AXN_ASSERTION_STATUS_MAP = "axnAssertionStatusMap",
    AXN_ATTRIBUTE_CLASSIFICATION = "axnAttributeClassification",
    AXN_ATTRIBUTE_LABEL = "axnAttributeLabel",
    AXN_ATTRIBUTE_TYPE_FIELD = "axnAttributeTypeField",
    AXN_ATTRIBUTE_TYPE = "axnAttributeType",
    AXN_AVAILABLE_PROPERTY_CATEGORY = "axnAvailablePropertyCategory",
    AXN_COMPANY = "axnCompany",
    AXN_COUNTRY = "axnCountry",
    AXN_IDENTITY_PROVIDER = "axnIdentityProvider",
    AXN_PROPERTY_TYPE = "axnPropertyType",
    AXN_REFERENCE_DATA_IDENTITY_PROVIDER = "axnReferenceDataIdentityProvider",
    AXN_RELYING_PARTY = "axnRelyingParty",
    AXN_RP_SERVICE_WITH_SOIDS = "axnRPServiceWithSOIDs",
    AXN_RP_SERVICE_ATTRIBUTE_PROPERTY = "axnRPServiceAttributeProperty",
    AXN_RP_SERVICE_ATTRIBUTE_PROPERTY_MAP = "axnRPServiceAttributePropertyMap",
    AXN_SELECTED_SERVICE_OFFERING_COMPANY = "axnSelectedServiceOfferingCompany",
    AXN_SELECTED_SERVICE_OFFERING_SO = "axnSelectedServiceOfferingSO",
    AXN_SERVICE_OFFERING = "axnServiceOffering",
    AXN_SERVICE_OFFERING_DATA_SOURCE = "axnServiceOfferingDataSource",
    AXN_TRANSACTION_TYPE = "axnTransactionType",
    SIMPLE_AXN_RP_SERVICE_WORKFLOW = "simpleAXNRPServiceWorkflow",
    SIMPLE_AXN_ADMIN_RP_SERVICE_WORKFLOW = "simpleAXNAdminRPServiceWorkflow",
    SIMPLE_AXN_WORKFLOW = "axnWorkflow",
    SIMPLE_AXN_ADMIN_WORKFLOW = "axnAdminWorkflow",
    DOCUMENTATION_LINK = "documentationLink",
    AXN_ACQUIRED_ATTRIBUTE = "axnAcquiredAttribute",
    AXN_ADMIN_USER_PROPERTY_BUNDLE = "axnAdminUserPropertyBundle",
    SIMPLE_AXN_RP_SERVICE = "simpleAxnRpService",
    AXN_AVAILABLE_ASSERTION_STATUS = "axnAvailableAssertionStatus",
    AXN_ATTRIBUTE_TYPE_FIELD_CUSTOMIZATION = "axnAttributeTypeFieldCustomization"
}